export interface INewOptions {
    id: string;
    value: string;
    label: string;
}

export const newOptions: INewOptions[] = [];
